<div class="app-layout">
  <app-header></app-header>

  <div class="layout-body">
    <!-- Mobile Menu Overlay -->
    <div
      class="mobile-overlay"
      [class.visible]="mobileMenuOpen$ | async"
      role="button"
      tabindex="0"
      aria-label="Close mobile menu"
      (click)="closeMobileMenu()"
      (keydown.enter)="closeMobileMenu()"
      (keydown.space)="closeMobileMenu()"></div>

    <app-left-menu></app-left-menu>

    <main class="main-content">
      <div class="content-wrapper">
        <router-outlet></router-outlet>
      </div>
      <app-footer></app-footer>
    </main>
  </div>
</div>
